import {IAppConfig} from '../interfaces/app-config.interface';
import {InjectionToken} from '@angular/core';

export const AppConfig: InjectionToken<IAppConfig> = new InjectionToken<IAppConfig>('AppConfig');
